import * as React from 'react';
import { LocationServicesCardComponent } from 'components/location/cards/LocationServicesCardComponent';
import { LocationServicesCardEditComponent } from 'components/location/cards/LocationServicesCardEditComponent';
import { createLocationServicesForm } from 'components/location/forms/createLocationServicesForm';
import { Location, ILocationConfig } from 'components/location/models/LocationModel';
import { LegacyForm } from 'lib/LegacyForm';
import { Panel } from 'ui/Panel';
import { locationApi } from '../LocationApi';

export interface LocationServicesCardProps {
    currentLocation: Location;
    setCurrentLocation: (location: Location) => void;
    locationConfig: ILocationConfig;
}

interface LocationServicesCardEditProps extends LocationServicesCardProps {
    onClose: () => void;
}

export class LocationServicesCardEdit extends React.Component<LocationServicesCardEditProps> {
    handleSubmit = async (data: any) => {
        const locationId = this.props.currentLocation._id;
        const response = await locationApi.update(locationId, {
            body: {
                services: data
            }
        });
        if (response.ok) {
            this.updateForm(response.body);
            this.props.setCurrentLocation(response.body);
        }
        this.props.onClose();
    };
    // eslint-disable-next-line @typescript-eslint/member-ordering
    form = new LegacyForm(createLocationServicesForm(this.props.locationConfig), this.handleSubmit);
    componentDidMount() {
        this.updateForm(this.props.currentLocation);
    }
    updateForm = ({ services }: Location) => this.form.update(services);
    render() {
        return (
            <LocationServicesCardEditComponent
                onClose={this.props.onClose}
                form={this.form}
                services={this.props.currentLocation.services}
            />
        );
    }
}

export const LocationServicesCard: React.FC<LocationServicesCardProps> = props => {
    const [isEditing, setIsEditing] = React.useState(false);
    const toggleState = React.useCallback(() => {
        setIsEditing(currentValue => !currentValue);
    }, []);
    return (
        <Panel title="Services" showAction={!isEditing} onClick={toggleState} divider>
            {isEditing ? (
                <LocationServicesCardEdit onClose={toggleState} {...props} />
            ) : (
                <LocationServicesCardComponent services={props.currentLocation.services} />
            )}
        </Panel>
    );
};
